// 新しい記事を上に記入
export const NEWS_CONTENTS = [
  {
    id: 0,
    date: "2023.03.23",
    contents: "クラウドファンディングサイトMakuakeにて目標金額達成",
  },
]
